/* eslint-disable quote-props */
import values from 'lodash/values';

export const categoryColorMaps = {
  'ギャグ・コメディ': 0xffcc00,
  '恋愛': 0xff94c4,
  'ファンタジー': 0x9882ae,
  'ホラー・ミステリー': 0xabb2b5,
  'エッセイ': 0xa0bf69,
  'アクション': 0x6d93de,
  '動物': 0xd48363,
  'グルメ': 0xf8a239,
  '日常': 0xff7373,
  'pixivコミック限定': 0x26a8e8,
  'BL': 0x59ccd9,
  'その他': 0x8fb8ed,
  'TL': 0xf184f1,
};

export const categoryColors = values(categoryColorMaps);

export const getCategoryColor = ({ name, prefix = null }) => {
  const hex = categoryColorMaps[name] || categoryColorMaps['その他'];
  return prefix ? `${prefix}${hex.toString(16)}` : hex;
};

export const getCategoryColorRGB = ({ name }) => {
  const hex = categoryColorMaps[name] || categoryColorMaps['その他'];
  return hex.toString(16).split(/(.{2})/).filter((i) => i.length).map((i) => parseInt(i, 16));
};

export const garaponColorMaps = {
  '7等': 0xdddddd,
  '6等': 0xff0040,
  '5等': 0x04b45f,
  '4等': 0x00bfff,
  '3等': 0xcc2efa,
  '2等': 0xc47222,
  '1等': 0xc0c0c0,
  '特等': 0xffd700,
};

export const getGaraponColor = ({ name, prefix = null }) => {
  const hex = garaponColorMaps[name] || garaponColorMaps['7等'];
  return prefix ? `${prefix}${hex.toString(16)}` : hex;
};

export const levelColors = [
  0xff3939,
  0xffff39,
  0x39ff39,
  0x3939ff,
  0xff39ff,
  0x39ffff,
];



// WEBPACK FOOTER //
// ./src/app/utils/Colors/Colors.js